import React from "react";
import {BranchesMainComponent} from "../../components";

export const BranchesPage = () => {
    return <BranchesMainComponent/>;
};
